import { colors } from '@uswitch/comms-ui.uswitch-theme'

export const container = {
  backgroundColor: '#141424',
  color: colors['grey-05'],
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 5,
  transform: 'translateY(-100%)',
  transition: 'all 0.3s ease-in-out'
}

export const headerContent = {
  width: '100%',
  boxSizing: 'border-box',
  padding: ['68px 16px 32px 16px', '36px 0px 32px 0px'],
  display: 'flex',
  flexDirection: 'column',
  alignItems: ['flex-start', 'center']
}

export const heading = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: ['12px', '16px']
}

export const headingText = {
  display: 'block',
  fontFamily: 'var(--font-family-heading)',
  fontSize: ['18px', '24px'],
  fontWeight: 600,
  lineHeight: ['24px', '32px'],
  margin: '0'
}

export const subheading = {
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '24px',
  margin: '0'
}

export const link = {
  textDecoration: 'underline',
  display: 'inline-block',
  cursor: 'pointer'
}

export const iconContainer = {
  mr: 'xs',
  display: 'flex',
  justifyContent: 'center'
}

export const icon = {
  size: ['1.75em', '2.25em']
}
